<template>
	<VPopup
		:target="target"
		:visible="isVisible"
		class="qty-popup"
		show-pointer
		position="bottom"
		@update:visible="handleClose"
	>
    <div
      v-if="row"
      class="qty-popup-content"
    >
      <VInputNumberRusV2
        ref="qtyInput"
        class="qty-popup-content-input"
        :type="Qty"
				v-model="qty"
        @keydown.enter="saveQty"
      >
        <template #helper-text>
          <div class="document-id-wrap">
            <div class="label">
              Номер фактуры:
            </div>
            <div class="value">
              {{ SWOracleDocumentId || '--' }}
            </div>
          </div>
          <VButton
            theme="link"
            :disabled="isLoading"
            @click="showProductCellHistory"
          >
            История товара {{ getFormattedMonthKey(monthKey) }}
          </VButton>
        </template>
      </VInputNumberRusV2>
      <div
        v-if="row"
        class="qty-popup-content-buttons-group"
      >
        <VButton
          theme="primary"
          :disabled="isLoading"
          @click="saveQty"
        >
          {{ row?.[monthKey]?.qty ? 'Сохранить' : 'Создать' }}
        </VButton>
        <VButton
          @click="handleClose"
        >
          Отмена
        </VButton>
      </div>
    </div>
  </VPopup>
</template>

<style lang="scss">
.mds-popup.qty-popup {
	width: 250px;
	padding: 10px;

	.qty-popup-content {
		display: flex;
		flex-direction: column;
		gap: 10px;

		&-input {
			.inner {
				.helper-text {
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					font-size: 13px;
					gap: 5px;

					.document-id-wrap {
						display: flex;
						flex-direction: row;

						> .label {
							color: var(--base-strong);
						}

						> .value {
							padding-left: 5px;
							color: var(--faint-text-strong);
						}
					}

				}
			}
		}

		&-buttons-group {
			display: flex;
			justify-content: space-between;
		}
	}
}
</style>

<script>

import Qty from "@/core/types/Qty.ts";
import ProductionPlansService from "../../../ProductionPlansService";
import GlobalLoader from "@/core/services/GlobalLoader/GlobalLoader";

export default {
	name:  'ProductionPlansChangeQtuPopup',
	props: {
		target: {
			type: [HTMLElement, null],
		},
		row: {
			type: Object,
		},
		monthKey: {
			type: String,
		}
	},

	emits: ['close', 'show-product-cell-history'],

	data() {
		return {
			lastQty:                    null,
			qty:                        null,
			selectedSWOracleDocumentId: null,
		};
	},

  setup() {
    return {
      Qty,
    }
  },

	computed: {
		isVisible() {
			return Boolean(this.target);
		},
		SWOracleDocumentId() {
			if (this.$core.utils.isObject(this.row)) {
				return this.row.qtyByDates[this.monthKey]?.sWOracleDocumentId;
			}

			return null;
		},
		isLoading() {
      return GlobalLoader.isVisible;
		},
	},

	watch: {
		/** От этого вотчера никуда не деваться, так что приходится мириться */
		target: {
			handler() {
				if (!this.row) return;

				this.qty = this.row.qtyByDates[this.monthKey]?.qty || Qty.zero();

				this.$nextTick(() => {
					this.$refs.qtyInput?.$el?.querySelector('input')
						.focus();
				});
			},
			deep: true
		}
	},

	methods: {

		handleClose() {
			this.$emit('close');
		},

		showLoadingDialog(title) {
			this.$core.dialogs.ReportsLoadingDialog.show(
				{
					visible: this.isLoading,
					title,
				},
			);
		},

		closeLoadingDialog() {
			this.$core.dialogs.ReportsLoadingDialog.hide();
		},

		showProductCellHistory() {
			this.$emit('show-product-cell-history');
			this.handleClose();
		},

		getFormattedMonthKey(monthKey) {
			if (!monthKey) return;
			const date = ProductionPlansService.formatMonthLabel(monthKey);
			return `за ${date.month} ${date.year}`;
		},

		async saveQty() {
			if (this.row.qtyByDates[this.monthKey]) {
				this.lastQty = this.row.qtyByDates[this.monthKey].qty;

				this.row.qtyByDates[this.monthKey].qty = this.qty;

				const position = {
					id: Number(this.row.qtyByDates[this.monthKey].id),
					qty: this.row.qtyByDates[this.monthKey].qty,
				};

				this.updatePosition(position);
				this.handleClose();

			} else {

				this.showLoadingDialog('создание позиции в плане')

				this.row.qtyByDates[this.monthKey] = {
					qty: this.qty,
					id: null,
					sWOracleDocumentId: null,
				};

				const data = [
					{
						plannedArrivalDate: this.monthKey,
						qty: this.qty,
					},
				];

				const payload = {
					productionSiteId: this.row.productionSite.id,
					productCode: this.row.code,
					data,
				};

				const result = await ProductionPlansService.addProducts(payload);
        this.handleClose();
        if (!result) {
          delete this.row[this.monthKey];
          this.$core.showNotification.error('Ошибка при добавлении позиции');
        }
        this.closeLoadingDialog();
			}
		},

		updatePosition(position) {
			ProductionPlansService
				.update(position)
				.catch(() => {
					this.row.qtyByDates[this.monthKey].qty = this.lastQty;
				});
		},
	}

};
</script>
